<template>
  <div class="card-body px-3 py-2">
    <div class="d-flex justify-content-between align-items-start mb-2">
      <span v-if="!isGuest"
        ><router-link
          class="btn btn-link underline-link-from-center p-0 m-0 font-weight-bold c-top-options"
          :to="`/me/orders/${order.scancode}`"
          >{{ $t('order') }} # {{ order.scancode }}</router-link
        >
        | {{ source }}</span
      >
      <span v-else>{{ $t('order') }} # {{ order.scancode }} | {{ source }}</span>
    </div>

    <WCOrderTracker
      v-if="order.status.stage >= 0 && order.status.stage < 3"
      class="w-100"
      :status="order.status"
    />

    <WCOrderPanelBodyInfo :order="order" :isDetailPage="isDetailPage" />
  </div>
</template>

<script>
import UserMixin from '@/modules/user/mixins/UserMixin';
import WCOrderTracker from '@/modules/orders/components/WCOrderTracker/WCOrderTracker.vue';
import WCOrderPanelBodyInfo from '@/modules/orders/components/WCOrderPanel/WCOrderPanelBodyInfo.vue';

export default {
  components: { WCOrderTracker, WCOrderPanelBodyInfo },
  props: {
    order: {
      type: Object,
      required: true,
    },
    isDetailPage: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [UserMixin],
  computed: {
    source() {
      return this.order.source === 'Web Cart' ? 'Online Purchase' : 'In Store Purchase';
    },
    lineItems() {
      return this.order.lineItems;
    },
  },
};
</script>

<style lang="scss" scoped>
.wc-top-options {
  vertical-align: top;
}
</style>
